import {
	Button,
	InputText,
	StylovyzeComposableDialog,
} from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';
import React from 'react';

import { useGlobalization } from '@Translations';
import { NewIntegrationContainer } from '../../IntegrationsTab.styles';
import { VaparSettingsFormValues } from '../../types/integration.types';
import {
	VaparAuthDialogContainer,
	VaparSettingsFooter,
} from './VaparSettings.styles';
import useVaparLogin from './useVaparLogin';

interface VaparAuthDialogProps {
	open: boolean;
	onCancel: () => void;
	onAuthorize: () => void;
}

export default function VaparAuthDialog({
	open,
	onCancel,
	onAuthorize,
}: VaparAuthDialogProps) {
	const { t } = useGlobalization();
	const { errors } = useFormikContext<VaparSettingsFormValues>();

	const { handleAuthToVapar } = useVaparLogin();

	return (
		<StylovyzeComposableDialog
			title={t('VAPAR Authentication')}
			onCancel={onCancel}
			open={open}>
			<NewIntegrationContainer>
				<VaparAuthDialogContainer>
					<div>
						<InputText
							fieldAttrs={{ name: 'integrationInfo.username' }}
							textField={{
								label: t('User Name'),
								error: !!errors.name,
								helperText: errors.name,
								disabled: false,
							}}
							dataCy="vapar-username-input"
						/>
						<InputText
							fieldAttrs={{ name: 'integrationInfo.password' }}
							textField={{
								label: t('Password'),
								error: !!errors.name,
								helperText: errors.name,
								disabled: false,
								type: 'password',
							}}
							dataCy="vapar-password-input"
						/>
					</div>
				</VaparAuthDialogContainer>
				<VaparSettingsFooter>
					<Button
						dataCy="cancelButton"
						color="secondary"
						variant="contained"
						onClick={() => {
							onCancel();
						}}>
						{t('Cancel')}
					</Button>
					<Button
						dataCy="continueButton"
						color="primary"
						variant="contained"
						onClick={async () => {
							await handleAuthToVapar();
							onAuthorize();
						}}>
						{t('Authenticate')}
					</Button>
				</VaparSettingsFooter>
			</NewIntegrationContainer>
		</StylovyzeComposableDialog>
	);
}
